export default {
  init (vue) {
    return {
      queryProtocol(provCode) {
        return vue.$http({
          method: 'GET',
          url: '/shop/jiyun/card/protocolQuery',
          params: {
            model: 202011,
            provCode: provCode
          }
        })
      },
      queryOrderArea() {
        return vue.$http({
          method: 'GET',
          url: `/shop/jiyun/card/queryOrderArea`,
          params: {
            model: 202011
          }
        })
      },
      queryNumberPool(data) {
        return vue.$http({
          method: 'POST',
          url: `/shop/jiyun/card/queryNumberPool`,
          data: data,
          params: {
            model: 202011
          }
        })
      },
      createOrder(data) {
        return vue.$http({
          method: 'POST',
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          withCredentials: true,
          url: `/shop/jiyun/card/createCardOrderOAO`,
          data: data,
          params: {
            model: 202011
          }
        })
      },
      queryXJOrderArea(data) {
        return vue.$http({
          method: 'GET',
          url: `/shop/xjyd/card/getCardArea`,
          params: data
        })
      },
      queryXJNumberPool(data) {
        return vue.$http({
          method: 'GET',
          url: `/shop/xjyd/card/queryPhonePool`,
          params: data
        })
      },
      createXJOrder(data) {
        return vue.$http({
          method: 'POST',
          url: `/shop/xjyd/card/createCardOrder`,
          headers: {'Content-Type': 'multipart/form-data'},
          data: data
        })
      }
    }
  }
}